export default __webpack_public_path__ + "static/media/ecu.70489124.svg";